<script setup>
import { useI18n } from 'vue-i18n'
import Map from '@/views/groups/Map.vue'
import Devices from '@/views/groups/Devices.vue'
import Users from '@/views/groups/Users.vue'
import axios from '@/helpers/axios'
import Header from '@/views/groups/Header.vue'
import Content from '@/views/groups/Content.vue'

definePage({
  meta: {
    layout: 'default',
    role: 'user'
  },
})

const { t } = useI18n()
const route = useRoute()
const uuid = route.params.uuid
const group = ref({})
const isAdmin = ref(false)


const getGroup = () => {
  axios.get('/groups/' + uuid).then(response => {
    group.value = response.data
  }).catch(e => {
    console.error(e)
  })
}

getGroup()
</script>

<template>
  <div>
    <Header
      :group="group"
      @update="getGroup"
    />
    <Map :group="group" class="mt-4" />
    <Content :group="group" class="mt-4" @update="getGroup" />
  </div>
</template>
